import { render, staticRenderFns } from "./Transportistas.vue?vue&type=template&id=04acf418"
import script from "./Transportistas.vue?vue&type=script&lang=js"
export * from "./Transportistas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports